(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[32684],{

/***/ 32684:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ SideEffects; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/styles/variables/bestparaquatlawyersVariables.module.scss
var bestparaquatlawyersVariables_module = __webpack_require__(57532);
var bestparaquatlawyersVariables_module_default = /*#__PURE__*/__webpack_require__.n(bestparaquatlawyersVariables_module);
;// CONCATENATED MODULE: ./src/components/bestparaquatlawyers/sideEffects/icons/Fatigue.tsx


function Fatigue() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "130",
        height: "130",
        fill: "none",
        viewBox: "0 0 130 130",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "65",
                cy: "65",
                r: "65",
                fill: "#EBF2E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_34_19)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#000",
                        d: "M98.81 75.592h3.93a2.977 2.977 0 002.978-2.977v-6.28a2.977 2.977 0 00-2.978-2.976h-3.93a2.977 2.977 0 00-2.978 2.977v6.279a2.977 2.977 0 002.977 2.977z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#CFC8C0",
                        d: "M96.48 53.931H31.406A2.405 2.405 0 0029 56.336v26.24a2.405 2.405 0 002.405 2.405H96.48a2.405 2.405 0 002.404-2.405v-26.24a2.405 2.405 0 00-2.404-2.405z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#EBF2E6",
                        d: "M70.649 58.015h-12.94A2.71 2.71 0 0055 60.725v17.481a2.71 2.71 0 002.71 2.71h12.939a2.71 2.71 0 002.71-2.71v-17.48a2.71 2.71 0 00-2.71-2.71zM90.641 58.015H77.702a2.71 2.71 0 00-2.71 2.71v17.481a2.71 2.71 0 002.71 2.71h12.94a2.71 2.71 0 002.71-2.71v-17.48a2.71 2.71 0 00-2.71-2.71z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#356E3F",
                        d: "M49.649 58.015h-12.94A2.71 2.71 0 0034 60.725v17.481a2.71 2.71 0 002.71 2.71h12.939a2.71 2.71 0 002.71-2.71v-17.48a2.71 2.71 0 00-2.71-2.71z"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#356E3F",
                d: "M63.626 27L48 49.196h11.793L56.375 63 71 41.3H60.33L63.626 27z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_34_19",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0H76.698V50H0z",
                        transform: "translate(29 35)"
                    })
                })
            })
        ]
    });
}
/* harmony default export */ var icons_Fatigue = (Fatigue);

;// CONCATENATED MODULE: ./src/components/bestparaquatlawyers/sideEffects/icons/Tremors.tsx


function Tremors() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "130",
        height: "130",
        fill: "none",
        viewBox: "0 0 130 130",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "65",
                cy: "65",
                r: "65",
                fill: "#EBF2E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_34_21)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#FDAA9F",
                        d: "M52.088 85.772l3.506-9.429a21.998 21.998 0 012.941-4.594c1.35-1.51 2.176-6.044 3.687-8.059 2.499-3.324-3.485-2.76-5.017 0-2.296 4.03-2.175 4.856-4.553 5.38-.504 0-.705-1.028-.685-1.552l-.141-4.553s1.894-12.089 2.176-13.318c1.39-5.903-2.78-7.313-3.425-4.372-.645 2.942-2.116 9.55-3.123 14.104h-.202c.363-3.728.847-8.321 1.31-11.283.584-3.667-1.43-6.568-3.103-4.775-.785.826-2.558 12.733-3.163 16.843l-.765.383c.12-2.941.261-6.044.463-8.3.322-3.426.927-6.952-1.25-6.952-2.88 0-3.888 17.066-4.029 20.148a37.297 37.297 0 01-.866-6.145c0-4.674-2.921-4.976-3.204-3.808-.765 3.264.705 14.406.705 14.406l3.345 17.589s9.55 6.629 15.393-1.713zM84.385 85.772l-5.581-8.381a20.587 20.587 0 00-3.909-3.808c-1.652-1.148-3.485-5.38-5.42-6.971-3.203-2.64 2.76-3.466 4.876-1.189 3.163 3.425 3.224 4.211 5.642 4.19.523 0 .463-1.168.322-1.671l-.886-4.473s-4.574-11.263-5.158-12.452c-2.7-5.44 1.047-7.756 2.337-5.037 1.29 2.72 4.25 8.805 6.246 12.976h.201c-1.209-3.546-2.74-7.918-3.868-10.679-1.39-3.465-.101-6.729 2.014-5.38.947.646 5.4 11.828 6.931 15.696l.826.181c-.765-2.84-1.632-5.883-2.337-8.059-1.088-3.264-2.498-6.548-.362-7.031 2.8-.665 7.676 15.715 8.582 18.717a35.42 35.42 0 00-.584-6.165c-1.108-4.533 1.713-5.52 2.237-4.453 1.51 3.002 2.619 14.103 2.619 14.103l.765 17.892s-7.897 8.764-15.493 1.994z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#356E3F",
                        fillRule: "evenodd",
                        d: "M89.951 38.18c.593-.096 1.328-.148 1.909.173.603.333.906.99 1.09 1.539.191.57.32 1.245.438 1.86l.007.035c.124.652.238 1.24.397 1.713.168.503.33.691.422.746.094.055.34.104.873.009.476-.086 1.02-.254 1.625-.44l.094-.03c.614-.189 1.294-.395 1.91-.482.588-.083 1.326-.09 1.9.35.576.44.758 1.15.825 1.738.07.614.037 1.317.002 1.955l-.009.177c-.033.597-.063 1.139-.037 1.607.03.545.131.795.213.888.085.096.325.23.864.337.429.084.919.132 1.461.184l.322.032c.638.064 1.341.145 1.941.328.587.178 1.248.505 1.571 1.187.318.67.175 1.383-.037 1.954-.216.583-.568 1.19-.889 1.733l-.07.12c-.309.522-.587.992-.776 1.428-.21.486-.239.775-.195.939.04.152.201.377.629.678.404.283.917.547 1.489.841l.041.02c.56.29 1.185.612 1.681.981.481.359.998.875 1.094 1.603.097.727-.269 1.364-.637 1.838-.373.48-.876.954-1.326 1.378l-.027.025c-.481.453-.906.856-1.207 1.243-.313.4-.379.644-.366.783.016.166.141.423.508.793.355.358.827.716 1.35 1.107l.069.05c.481.36 1.006.753 1.412 1.153.399.394.85.953.855 1.649.019.715-.334 1.362-.713 1.879-.391.533-.903 1.053-1.363 1.512l-.1.1c-.438.439-.816.816-1.084 1.16a1.991 1.991 0 00-.269.428c-.032.077-.031.109-.031.109l-.002-.01-1.468.307c-.076-.363 0-.703.115-.981.116-.277.288-.538.47-.773.329-.423.775-.868 1.191-1.283l.118-.118c.47-.47.9-.911 1.213-1.338.322-.44.43-.748.424-.955l-.001-.012v-.013c0-.054-.049-.238-.409-.593-.331-.327-.783-.665-1.302-1.053l-.023-.017c-.504-.377-1.07-.801-1.516-1.25-.433-.437-.872-1.01-.937-1.712-.068-.727.299-1.362.675-1.844.38-.488.888-.966 1.34-1.391l.023-.022c.482-.454.902-.851 1.195-1.23.306-.394.351-.613.336-.722-.014-.108-.112-.305-.504-.597-.377-.281-.885-.548-1.47-.85-.028-.013-.055-.028-.083-.042-.536-.275-1.132-.581-1.622-.925-.5-.35-1.037-.838-1.218-1.522-.179-.672.027-1.36.269-1.92.228-.526.554-1.077.85-1.577l.08-.136c.332-.562.613-1.055.774-1.491.166-.448.144-.675.089-.79-.05-.105-.2-.259-.653-.397-.439-.134-1.004-.205-1.653-.27l-.297-.029c-.539-.051-1.12-.107-1.628-.208-.576-.114-1.26-.319-1.699-.816-.441-.501-.552-1.208-.585-1.796-.031-.558.004-1.186.036-1.764l.01-.186c.036-.656.059-1.235.006-1.703-.057-.493-.178-.665-.246-.718-.07-.053-.275-.126-.78-.055-.477.067-1.04.235-1.676.43l-.125.04c-.574.177-1.202.37-1.772.473-.581.104-1.306.156-1.898-.192-.592-.348-.897-1.003-1.084-1.563-.195-.58-.326-1.264-.444-1.883l-.005-.024c-.125-.653-.237-1.235-.393-1.701-.167-.498-.322-.662-.394-.702-.094-.052-.368-.099-.943-.006-.525.085-1.13.254-1.783.436l-.032.009c-.638.177-1.33.37-1.93.452-.303.042-.62.061-.92.024-.299-.037-.638-.138-.918-.39l1.004-1.114c-.008-.008-.013-.01-.013-.01s.028.015.112.026c.119.014.292.01.53-.022.48-.066 1.069-.226 1.733-.411l.074-.02c.618-.173 1.294-.362 1.903-.46zM44.731 40.548c-.19.608-.527 1.255-1.188 1.617l-.001.001c-.603.329-1.328.225-1.888.086-.568-.14-1.194-.382-1.77-.603l-.09-.036c-.628-.24-1.193-.453-1.681-.564-.52-.117-.755-.07-.84-.02-.077.044-.222.204-.353.691-.124.46-.192 1.038-.262 1.694l-.012.109c-.064.598-.135 1.254-.269 1.825-.136.58-.377 1.256-.918 1.671-.538.412-1.257.476-1.856.467-.58-.009-1.228-.095-1.82-.174a73.913 73.913 0 00-.143-.019c-.658-.087-1.237-.157-1.709-.142-.502.015-.668.122-.712.172-.038.043-.121.203-.061.681.057.453.215.998.407 1.625l.05.165c.171.556.358 1.165.464 1.728.112.596.169 1.309-.122 1.915-.298.621-.905 1.002-1.448 1.26-.527.251-1.147.455-1.71.64l-.112.037c-.62.204-1.159.388-1.571.604-.431.227-.55.4-.576.49-.025.084-.021.29.225.715.235.405.595.85 1.014 1.358l.069.083c.382.462.804.974 1.118 1.475.322.512.631 1.166.54 1.856-.093.7-.567 1.235-1.017 1.628-.443.386-.998.747-1.498 1.072l-.069.044c-.544.354-1.021.67-1.376.992-.365.33-.476.56-.49.708-.012.132.052.372.372.766.308.379.747.774 1.247 1.207l.167.145c.432.373.896.775 1.26 1.169.384.416.826.997.826 1.68v.033c-.033.742-.46 1.334-.91 1.78-.456.45-1.038.85-1.57 1.2l-.365.238c-.409.265-.773.501-1.075.738-.19.148-.328.276-.42.385a.494.494 0 00-.108.172l-1.469-.306c.07-.333.244-.61.428-.829.185-.222.413-.423.645-.604.36-.282.8-.567 1.218-.838l.324-.21c.531-.35.999-.678 1.337-1.013.332-.328.449-.574.464-.757-.007-.074-.081-.277-.427-.652-.302-.327-.697-.669-1.14-1.052l-.168-.146c-.488-.423-1.026-.899-1.428-1.394-.39-.48-.77-1.116-.701-1.85.067-.719.525-1.273.975-1.681.46-.418 1.045-.8 1.567-1.138l.023-.015c.538-.35 1.013-.66 1.375-.974.38-.332.498-.558.516-.695.019-.145-.041-.413-.323-.862-.261-.416-.626-.858-1.03-1.348l-.044-.052c-.402-.487-.847-1.03-1.155-1.561-.296-.512-.572-1.19-.366-1.891.206-.696.795-1.12 1.318-1.394.541-.284 1.203-.505 1.799-.7l.08-.027c.594-.195 1.129-.372 1.566-.58.477-.227.676-.42.74-.555.072-.149.102-.45 0-.99-.088-.474-.25-1.002-.427-1.578l-.047-.152c-.185-.606-.385-1.275-.46-1.877-.073-.576-.062-1.31.423-1.86.48-.545 1.209-.662 1.793-.68.614-.018 1.315.071 1.951.155l.118.016c.62.082 1.182.157 1.67.164.55.009.815-.076.922-.158.103-.079.248-.303.37-.824.112-.476.173-1.047.241-1.68l.008-.07c.068-.632.145-1.33.305-1.924.153-.568.431-1.241 1.05-1.6.609-.353 1.341-.275 1.923-.144.613.14 1.283.395 1.887.627l.05.02c.612.235 1.16.445 1.635.563.524.13.744.088.807.054.165-.092.336-.3.477-.75.139-.445.21-1.004.267-1.631l.037-.441c.039-.475.08-.973.15-1.402.048-.29.114-.584.217-.852.102-.265.257-.55.509-.772l.992 1.124a.518.518 0 00-.1.185 2.946 2.946 0 00-.138.559c-.06.363-.093.772-.13 1.229l-.044.504c-.056.631-.137 1.332-.329 1.945zM65.307 74.55a.225.225 0 00-.026.067l1.458.35c-.08.338-.297.585-.479.75-.19.171-.42.32-.645.449-.332.19-.74.384-1.13.57-.129.06-.255.12-.377.179-.522.253-.977.494-1.303.746-.325.25-.388.408-.397.473a.471.471 0 00.037.08c.053.096.15.225.302.388.275.297.642.615 1.055.975.05.042.1.085.15.13.45.391.949.834 1.315 1.279.335.409.737 1.028.591 1.734-.15.73-.782 1.105-1.26 1.31-.512.221-1.145.37-1.71.5l-.175.039c-.529.12-1.003.226-1.394.363-.213.074-.37.147-.479.215-.107.069-.131.11-.132.112-.029.054-.071.268.021.774.077.417.214.888.363 1.402l.053.181c.16.554.333 1.17.39 1.708.05.48.047 1.233-.544 1.694-.294.23-.633.299-.927.305a3.139 3.139 0 01-.862-.121c-.546-.146-1.157-.41-1.708-.65l-.113-.05c-.533-.233-1.015-.444-1.434-.576a2.497 2.497 0 00-.517-.116.615.615 0 00-.117 0 .44.44 0 00-.032.05 1.693 1.693 0 00-.142.418c-.093.402-.138.926-.174 1.515l-.02.317c-.027.472-.056.969-.114 1.39-.036.261-.087.529-.168.769-.077.225-.21.515-.467.727l-.952-1.16c-.028.023-.039.04-.039.04s.015-.024.038-.09c.037-.11.072-.27.102-.49.049-.358.074-.779.102-1.247l.02-.35c.037-.58.086-1.22.21-1.758.063-.272.152-.553.29-.802.137-.251.346-.513.667-.673.31-.155.641-.173.918-.15.281.022.57.093.845.18.5.157 1.056.4 1.566.624.044.02.089.038.132.058.573.25 1.077.464 1.493.574a1.694 1.694 0 00.457.071c.01-.053.017-.157-.002-.342-.04-.383-.172-.87-.34-1.447l-.052-.183c-.146-.5-.306-1.05-.397-1.548-.095-.52-.163-1.2.13-1.75.309-.578.948-.866 1.441-1.038.478-.166 1.04-.293 1.55-.408l.18-.04c.588-.134 1.085-.257 1.45-.414.29-.125.366-.215.383-.24-.004-.028-.03-.17-.28-.475-.274-.333-.678-.696-1.142-1.1l-.15-.13c-.4-.349-.835-.725-1.169-1.086a3.62 3.62 0 01-.512-.677c-.133-.239-.252-.55-.225-.904.05-.715.536-1.226.979-1.568.461-.356 1.042-.655 1.565-.908l.436-.208c.373-.177.702-.334.98-.493a2.34 2.34 0 00.386-.262.39.39 0 00.05-.053zM60.1 89.816h-.002.002zm5.207-15.267h-.001zM75.043 41.223c-.11.261-.29.544-.592.737-.296.187-.626.235-.902.237a3.902 3.902 0 01-.855-.105c-.506-.112-1.076-.304-1.6-.48l-.15-.05c-.592-.2-1.115-.367-1.538-.44a1.666 1.666 0 00-.446-.03l-.013.002c-.005.053-.004.157.033.342.075.374.25.844.468 1.399l.068.173c.19.482.4 1.013.537 1.5.144.512.27 1.179.037 1.755-.25.613-.857.965-1.335 1.185-.467.215-1.024.395-1.527.558l-.155.05c-.574.187-1.057.353-1.407.542-.271.147-.342.243-.359.27.009.032.054.152.303.387.303.285.736.581 1.245.929l.016.01c.477.325 1.021.696 1.443 1.092.405.38.864.934.864 1.645 0 .708-.443 1.254-.852 1.63-.427.393-.976.743-1.47 1.044l-.383.23c-.364.218-.685.41-.95.6a2.294 2.294 0 00-.355.297.402.402 0 00-.046.057.218.218 0 00.02-.068l-1.487-.204c.047-.344.236-.61.401-.793.172-.19.385-.36.596-.51.318-.227.714-.464 1.091-.69l.333-.2c.495-.302.928-.585 1.234-.867.325-.298.368-.467.368-.526 0-.053-.045-.227-.39-.552-.325-.304-.77-.61-1.277-.956l-.043-.029c-.467-.318-.991-.675-1.386-1.047-.378-.356-.852-.92-.768-1.652.086-.74.682-1.17 1.139-1.416.49-.265 1.107-.47 1.656-.65l.142-.045c.525-.17.995-.323 1.376-.498.453-.21.56-.356.573-.388.028-.068.047-.293-.09-.784-.115-.409-.295-.863-.49-1.359l-.068-.17c-.21-.534-.438-1.127-.543-1.655-.095-.476-.158-1.217.38-1.731.271-.26.604-.363.897-.397a3.11 3.11 0 01.873.042c.558.095 1.191.304 1.762.495l.134.045c.546.184 1.04.35 1.463.443.225.05.397.071.52.07.048 0 .08-.004.1-.007a.445.445 0 00.021-.046 1.74 1.74 0 00.1-.434c.053-.415.048-.944.031-1.537l-.007-.24c-.015-.5-.03-1.032-.004-1.486.016-.266.048-.541.116-.79.065-.24.185-.54.439-.768l1.002 1.116c.026-.024.037-.041.037-.041s-.014.023-.031.086c-.03.107-.052.266-.066.486-.022.381-.008.836.007 1.343l.007.252c.016.58.027 1.222-.043 1.769a3.202 3.202 0 01-.204.823zM65.122 56.79v-.001zm3.773-15.684l.001-.001h-.001z",
                        clipRule: "evenodd"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_34_21",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0H90.363V60H0z",
                        transform: "translate(21 35)"
                    })
                })
            })
        ]
    });
}
/* harmony default export */ var icons_Tremors = (Tremors);

;// CONCATENATED MODULE: ./src/components/bestparaquatlawyers/sideEffects/icons/Slowness.tsx


function Slowness() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "130",
        height: "130",
        fill: "none",
        viewBox: "0 0 130 130",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "65",
                cy: "65",
                r: "65",
                fill: "#EBF2E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_34_22)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#595754",
                        d: "M60.987 42.409a41.118 41.118 0 00-.601 17.733c10.693 4.898 25.352 4.352 25.352 4.352C87.86 59.798 87.2 50.91 87.74 40l-26.753 2.409z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#356E3F",
                        d: "M60.666 69.251s-2.423 10.668-.84 12.348c1.581 1.68 31.9 4.049 40.67 1.883 8.772-2.166-15.459-17.45-15.459-17.45l-24.37 3.22z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#604A91",
                        d: "M59.845 73.502c-.52 3.178-.921 7.126 0 8.097.621.648 5.507 1.397 11.775 2.024L59.845 73.502zM87.5 67.713l-.46-.304-19.305.972-7.069.93s-.1.406-.24 1.074C63.79 73.057 72.54 77.51 87.5 67.713z",
                        opacity: "0.31"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#3B3937",
                        d: "M60.166 57.591a20.821 20.821 0 00-.18 12.146A47.947 47.947 0 0088.2 68.34a32.545 32.545 0 00-.881-11.943s-15.38 3.016-27.154 1.194z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#26221C",
                        d: "M94.209 72.308s-2.524-1.58-3.745 2.53l3.745-2.53z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#595754",
                        d: "M29.487 42.409a40.262 40.262 0 00-2.704 14.413c8.892 7.773 28.316 5.202 28.316 5.202 0-7.145-.78-7.59 1.062-19.615H29.486z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#356E3F",
                        d: "M26.123 68.239s-3.865 8.927-1.282 11.113S51.475 90.506 58.083 89.98c6.608-.527 10.353-3.38 6.008-8.097-4.346-4.717-10.994-13.462-10.994-13.462s-25.693-9.453-26.974-.182z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#604A91",
                        d: "M53.537 69.049l-25.412-3.806a3.86 3.86 0 00-1.362 1.24 3.912 3.912 0 00-.64 1.736c1.321 2.409 4.726 5.465 13.417 6.984 10.252 1.801 14.338-1.235 16.02-3.523a100.22 100.22 0 01-2.023-2.631z",
                        opacity: "0.31"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#3B3937",
                        d: "M27.144 56.295a13.96 13.96 0 00-2.59 4.969 14.052 14.052 0 00-.434 5.598 1.304 1.304 0 00.721 1.033c3.384 1.599 19.364 8.725 30.358 4.271.273-4.001.18-8.02-.28-12.004 0 0-10.473 3.806-27.775-3.867z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#26221C",
                        d: "M49.652 76.943s1.442-4.352 7.11-3.218l-7.11 3.218zM52.336 80.142s1.442-4.353 7.109-3.219l-7.11 3.219z"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_34_22",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0H80.702V50H0z",
                        transform: "translate(24 40)"
                    })
                })
            })
        ]
    });
}
/* harmony default export */ var icons_Slowness = (Slowness);

;// CONCATENATED MODULE: ./src/components/bestparaquatlawyers/sideEffects/icons/Speech.tsx


function Speech() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "130",
        height: "130",
        fill: "none",
        viewBox: "0 0 130 130",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "65",
                cy: "65",
                r: "65",
                fill: "#EBF2E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_34_23)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#356E3F",
                        d: "M56.417 35C42.533 35 31.25 45.486 31.25 58.593a22.334 22.334 0 003.376 11.786 33.658 33.658 0 01-6.648 3.125 17.449 17.449 0 0010.486 1.594 25.9 25.9 0 0017.973 7.11c13.904 0 25.166-10.487 25.166-23.615C81.604 45.465 70.32 35 56.417 35z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M48.594 59.348a1.95 1.95 0 11-3.9 0 1.95 1.95 0 013.9 0zM58.535 59.348a1.95 1.95 0 11-3.9 0 1.95 1.95 0 013.9 0zM68.475 59.348a1.95 1.95 0 11-3.9 0 1.95 1.95 0 013.9 0z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        stroke: "#356E3F",
                        strokeWidth: "0.5",
                        d: "M97.138 85.901a26.406 26.406 0 004.712 2.292 13.632 13.632 0 01-7.54.96l-.122-.019-.09.085a20.197 20.197 0 01-14.024 5.552h-.001c-10.824 0-19.59-8.291-19.59-18.373s8.766-18.373 19.59-18.373c10.845 0 19.61 8.291 19.61 18.373a17.408 17.408 0 01-2.626 9.159l-.132.213.213.131z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#356E3F",
                        d: "M86.26 76.985a1.531 1.531 0 103.061 0 1.531 1.531 0 00-3.062 0zM78.416 76.985a1.531 1.531 0 103.062 0 1.531 1.531 0 00-3.062 0zM70.573 76.985a1.531 1.531 0 103.062 0 1.531 1.531 0 00-3.063 0z"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_34_23",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0H74.491V60H0z",
                        transform: "translate(28 35)"
                    })
                })
            })
        ]
    });
}
/* harmony default export */ var icons_Speech = (Speech);

;// CONCATENATED MODULE: ./src/components/bestparaquatlawyers/sideEffects/icons/Writing.tsx


function Writing() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "130",
        height: "130",
        fill: "none",
        viewBox: "0 0 130 130",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "65",
                cy: "65",
                r: "65",
                fill: "#EBF2E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_34_20)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#356E3F",
                        d: "M72.769 35H33v50.048h39.769V35z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M58.25 41.893c-1.742 0-2.683-.675-3.601-1.329-.918-.654-1.806-1.29-3.544-1.171-1.627.116-2.728.561-3.705.959-1.249.508-2.324.949-3.904.389-2.497-.886-5.925-1.433-7.378-.062l-.4-.423c1.641-1.55 5.194-1.045 7.972-.063 1.368.486 2.259.117 3.486-.38 1.016-.413 2.17-.884 3.884-1 1.946-.132 2.95.581 3.921 1.278.971.697 1.905 1.36 3.844 1.196 2.425-.207 3.048-.786 3.708-1.394.41-.382.834-.776 1.654-1.074 2.182-.795 5.841 1.648 5.997 1.752l-.326.482c-.035-.024-3.568-2.38-5.472-1.69-.71.26-1.073.597-1.458.955-.697.653-1.43 1.328-4.052 1.55a8.996 8.996 0 01-.626.025zM40.768 47.456c-2.148 0-4.88-1.82-5.01-1.91l.324-.482c.035.024 3.568 2.38 5.473 1.688.71-.258 1.073-.596 1.458-.953.697-.653 1.429-1.328 4.052-1.55 2.153-.184 3.21.57 4.233 1.3.93.663 1.804 1.29 3.544 1.172 1.626-.11 2.728-.561 3.703-.96 1.25-.509 2.33-.948 3.905-.39 2.497.887 5.926 1.434 7.378.063l.4.423c-1.642 1.55-5.194 1.046-7.971.062-1.368-.484-2.26-.116-3.486.38-1.018.415-2.17.884-3.885 1.001-1.945.133-2.95-.58-3.92-1.278-.972-.697-1.906-1.361-3.845-1.195-2.425.207-3.047.785-3.707 1.394-.41.381-.835.775-1.655 1.074a2.882 2.882 0 01-.99.161z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#E6BD92",
                        d: "M51.095 49.03c-.452 2.323 11.353 5.19 11.353 5.19s-6.148.358-8.788 1.5c-.116.31-.445 2.724 2.72 2.082 3.165-.64 7.539-.116 7.539-.116s4.829.755 6.412.982c1.584.227 5.318-1.358 4.037-4.49-1.282-3.13-3.32-5.656-4.905-6.298-1.584-.641-4.714-1.773-7.883-1.585-3.168.189-1.002-.59-4.488.378a30.638 30.638 0 00-5.997 2.356z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#FFD1A3",
                        d: "M67.43 81.14s-8.332-2.681-16-16.1c-.851-1.489-3.848-12.124-3.848-12.124s3.287-2.245 6.659 7.3c2.506.686 11.941 8.562 11.941 8.562L67.43 81.14zM67.378 47.283a3.312 3.312 0 01-3.563 3.038l-12.87-1.859c-1.823-.145-3.932-1.002-3.788-2.825.145-1.823 2.061-2.596 5.096-2.038l12.083.125a3.312 3.312 0 013.042 3.559z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#FFE6CF",
                        d: "M47.624 53.057c.28.867.354 1.518.772 2.685.507-.062.55-.813.517-1.077-.15-1.187-1.364-1.84-1.289-1.608z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#FFD1A3",
                        d: "M64.822 50.248c.785-.29 6.943 5.495 6.943 5.495-.653 5.88-1.782 11.154-5.577 13.035 0 0-2.333 9.898 1.248 12.361 3.58 2.463 10.671 6.235 10.671 6.235L83.84 95c7.035-1.162 12.37-4.216 14.042-11.335L89.574 74.7s-5.434-17.88-6.64-21.688c-1.206-3.809-14.4-9.248-18.59-9.295-2.99 2.62.478 6.531.478 6.531z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#636363",
                        d: "M91.908 80.77l2.631-4.007a.562.562 0 00-.159-.775L58.29 52.18l-16.6-8.554-1.208 1.84 14.453 11.827 36.2 23.638a.56.56 0 00.774-.161z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#FFB43D",
                        d: "M56.212 58.119l3.352-5.108-1.278-.839-3.352 5.108 1.278.839zM43.357 47.819l1.19.973 1.81-2.76-1.366-.704-1.634 2.49z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#E0E0E0",
                        d: "M91.134 80.932a.56.56 0 00.774-.161l2.631-4.008a.557.557 0 00-.03-.652l-2.473 3.77a.56.56 0 01-.774.161l-36.2-23.639L40.905 44.82l-.425.647 14.453 11.827 36.2 23.638z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#A8A8A8",
                        d: "M38.506 43.114l.245-.374 2.782 1.126-.888 1.351-2.139-2.103z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#E0E0E0",
                        d: "M40.87 44.874l-2.139-2.104-.225.344 2.139 2.103.225-.343z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#636363",
                        d: "M92.133 80.428l2.181-3.323 1.693 1.111a1.988 1.988 0 01-2.18 3.323l-1.694-1.11z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#E0E0E0",
                        d: "M96.579 80.968a2.03 2.03 0 00.198-.395 1.988 1.988 0 01-2.468.233l-1.694-1.112-.482.735 1.694 1.111a1.988 1.988 0 002.752-.572z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#FFB43D",
                        d: "M90.634 78.377l1.216-1.854-16.037-10.526-1.216 1.853 16.037 10.527z"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_34_20",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0H64.877V60H0z",
                        transform: "translate(33 35)"
                    })
                })
            })
        ]
    });
}
/* harmony default export */ var icons_Writing = (Writing);

;// CONCATENATED MODULE: ./src/components/bestparaquatlawyers/sideEffects/icons/Smell.tsx


function Smell() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "130",
        height: "130",
        fill: "none",
        viewBox: "0 0 130 130",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "65",
                cy: "65",
                r: "65",
                fill: "#EBF2E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_34_24)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#FDAA9F",
                        d: "M70.744 83.737s26.306-.57 3.322-46.902a3.544 3.544 0 00-6.328.395l-13.81 31.068s-20.073 18.429 16.816 15.44z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#26221C",
                        d: "M55.463 80.4a1.677 1.677 0 01.538-1.851 4.603 4.603 0 011.724-1.029c1.204-.4 2.465-.603 3.733-.6a18.776 18.776 0 017.23 1.376 31.974 31.974 0 01-3.655.19H61.49a24.498 24.498 0 00-3.449.205c-1.107.221-2.388.411-2.578 1.709z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#FDAA9F",
                        d: "M60.272 65.894s-16.91-2.389-11.643 13.256l11.643-13.256z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#26221C",
                        d: "M60.272 65.894c-1.861.089-3.71.354-5.52.79a9.728 9.728 0 00-4.572 2.358 3.401 3.401 0 00-.776.949c-.247.339-.444.712-.585 1.107-.126.395-.285.791-.395 1.218-.111.427-.095.87-.158 1.297a5.578 5.578 0 000 1.36v1.377c.142.917.284 1.835.363 2.8a36.142 36.142 0 01-1.123-2.658 16.035 16.035 0 01-.474-2.895 7.325 7.325 0 012.024-5.678 9.492 9.492 0 015.458-2.452 14.365 14.365 0 015.758.427z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#FDCAB6",
                        d: "M77.925 72.095c-2.436.775-5.773-2.832-7.45-8.068-1.677-5.236-1.06-10.108 1.376-10.899 2.436-.79 5.774 2.832 7.45 8.068 1.677 5.236 1.06 10.108-1.376 10.899z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#356E3F",
                        d: "M62.66 83.706a.854.854 0 100-1.709.854.854 0 000 1.709zM67.707 88.34a1.519 1.519 0 100-3.037 1.519 1.519 0 000 3.037zM75.885 92.785a2.167 2.167 0 11-2.152-2.15 2.151 2.151 0 012.152 2.15z"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_34_24",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0H36.478V60H0z",
                        transform: "translate(47 35)"
                    })
                })
            })
        ]
    });
}
/* harmony default export */ var icons_Smell = (Smell);

// EXTERNAL MODULE: ./src/components/shared/featureList/index.tsx
var featureList = __webpack_require__(73367);
;// CONCATENATED MODULE: ./src/components/bestparaquatlawyers/sideEffects/index.tsx










const sideEffectList = [
    {
        title: "Speech Changes",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_Speech, {})
    },
    {
        title: "Tremors",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_Tremors, {})
    },
    {
        title: "Fatigue/ Apathy",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_Fatigue, {})
    },
    {
        title: "Diminished Smell",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_Smell, {})
    },
    {
        title: "Slowness of Movement",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_Slowness, {})
    },
    {
        title: "Writing Changes",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_Writing, {})
    }, 
];
function SideEffects() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(featureList/* default */.Z, {
        featureList: sideEffectList,
        mainTitle: "What Are Early Signs and Symptoms of Parkinson's Disease?",
        mainDescription: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
            className: "flex flex-col",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: "Parkinson's is a progressively debilitating neurological condition that develops as the dopamine-producing neurons in the body begin to deteriorate. Often undetected at early stages, Parkinson's disease consistently affects the whole body in very significant ways."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "mt-4",
                    children: "While treatment can help through the developing stages, Parkinson's disease is a progressive illness, where patients' conditions inevitably deteriorate over time. During the final phase of Parkinson's, victims are often wheelchair-constrained and eventually bedridden, needing constant care. Symptoms of Parkinson's disease:"
                })
            ]
        }),
        classes: {
            mainSectionClasses: "mx-auto lg:max-w-7xl flex justify-center items-start flex-col px-8 mb-10",
            mainTitleClasses: "text-2xl font-bold text-left mb-8 leading-9",
            mainDescriptionClasses: "text-sm text-left md:text-lg leading-9",
            innerSectionClasses: "flex flex-wrap justify-center mt-12 gap-16",
            oneBoxClasses: "flex flex-col items-center justify-center w-52 md:w-64 mx-10 text-center",
            titleClasses: "mt-2 text-sm md:text-lg ",
            iconClasses: " "
        },
        colors: {
            mainDescriptionColor: (bestparaquatlawyersVariables_module_default()).grey
        }
    });
}


/***/ }),

/***/ 73367:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ FeatureList; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(35533);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _components_svg_chevron__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(39717);
/* harmony import */ var _lib_shared_routerQueriesToString__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(78418);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);







function FeatureList({ featureList , mainTitle , mainDescription , colors , classes  }) {
    const outerSectionStyle = {
        "--bg": `${colors?.bgColor ?? "transparent"}`,
        "--iconColor": `${colors?.iconColor ?? "gray"}`
    };
    const { query  } = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        style: outerSectionStyle,
        className: `mt-10 lg:mt-16 ${(_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().mainSection)} `,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: classes?.mainSectionClasses ?? "",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                    style: {
                        color: colors?.mainTitleColor ?? "black"
                    },
                    className: classes?.mainTitleClasses ?? "text-center text-xl lg:text-2xl mb-14",
                    children: mainTitle
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    style: {
                        color: colors?.mainDescriptionColor ?? "black"
                    },
                    className: classes?.mainDescriptionClasses ?? "",
                    children: mainDescription
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: classes?.innerSectionClasses ?? "lg:flex flex-wrap justify-center",
                    children: featureList?.map((item, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: classes?.oneBoxClasses ? `${classes?.oneBoxClasses} ${colors?.iconColor ? (_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().item) : ""}` : `text-center mb-12 lg:mb-20 w-full lg:w-1/3   ${colors?.iconColor ? (_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().item) : ""} `,
                            children: [
                                item.path ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: classes?.iconClasses ?? "relative mb-14 w-[190px] h-[190px]  mx-auto",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                        src: item.path,
                                        layout: "fill",
                                        alt: item.title
                                    })
                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: classes?.iconClasses ?? "children:w-12 children:h-12 children:mx-auto ",
                                    children: item.icon
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                    style: {
                                        color: colors?.titleColor ?? "black"
                                    },
                                    className: classes?.titleClasses ?? "font-medium text-lg lg:text-xl mt-6",
                                    children: item.title
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    style: {
                                        color: colors?.descriptionColor ?? "black"
                                    },
                                    className: classes?.descriptionClasses ?? "font-light text-sm text-center w-4/5 mx-auto mt-2",
                                    children: item.description
                                }),
                                item.tool && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                    href: `/tools/${item.tool}?${(0,_lib_shared_routerQueriesToString__WEBPACK_IMPORTED_MODULE_6__/* .gettingQueriesAsString */ .r)(query, "start")}`,
                                    className: classes?.toolClasses ? `${classes?.toolClasses} ${(_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().link)}` : `mt-4 flex gap-2 items-center md:mt-auto ${(_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().link)}`,
                                    style: {
                                        color: colors?.toolColor ?? "black"
                                    },
                                    children: [
                                        "Details",
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_svg_chevron__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                            className: "transform rotate-180",
                                            fill: colors?.chevronColor
                                        })
                                    ]
                                })
                            ]
                        }, index))
                })
            ]
        })
    });
}


/***/ }),

/***/ 39717:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Chevron; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function Chevron({ className , fill  }) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "8",
        height: "12",
        viewBox: "0 0 8 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7.4 1.4L6 0L0 6L6 12L7.4 10.6L2.8 6L7.4 1.4Z",
            fill: fill ?? "black"
        })
    });
}


/***/ }),

/***/ 35533:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#16556d","lightPrimaryColor":"#dff5f9","whyUsItemTitle":"#005670","offerCallNumber":"#006336","slogan":"#018484","progressColor":"#1c75bc","linkColorDefault":"#018484","buttonBgColorDefault":"#01847f","whyUsBackgroundColor":"#005c58","whyUsColor":"#fff","melon":"#fe895c","darkSeaGreen":"#0e7d3f","marigold":"#ffcb03","fadedRed":"#cd2f32","dodgerBlue":"#4f85ff","pinkishGrey":"#bfbfbf","sea":"#329eaa","softBlue":"#6b67e9","slightlyBlack":"#161616","tealGreen":"#83b855","greyish":"#b3b3b3","paleGrey":"#f8f9fa","navy":"#011d41","pagePaddingX":"1rem","autumnGlory":"#3ea636","blackLead":"#464c4d","primary":"#b91c45","shiningSilver":"#c8c8c8","bleachedSilk":"#f3f2f2","blackBeauty":"#28252b","battleshipGrey":"#6d7577","winterSolstice":"#47525d","puritanGrey":"#a8aeaf","nero":"#242626","direWolf":"#272828","placeboBlue":"#ebf4fd","chiGong":"#ff1919","mississippiRiver":"#386189","spiroDiscoBall":"#0ac5ff","linkColor":"#565656","gray":"#eaeaea","grayBg":"#fafafa","graydark":"#b3b3b3","grayLight":"#ececec","orange":"#faa931","orangeDark":"#ff700e","orangeLight":"#f1c19c","orangePopup":"#f7951e","Blue":"#5dbbfe","blueDark":"#1b4874","green":"#0a6938","red":"#f85650","redLight":"#fff5f3","cyan":"#37c8e3","blueAster":"#266199","assault":"#184070","lucea":"#79b4e2","distantHorizon":"#f4f9fa","yellow":"#fff9e7","lynxScreenBlue":"#27aae1","singingBlue":"#0375a3","citrusSplash":"#ffc600","youngNight":"#232323","offerBorderColor":"#e4e7eb","defaultButtonColor":"#00b2b8","defaultProgressColor":"#838282","poseidon":"#143a56","vitamin":"#f90","queenOfTheNight":"#275376","trolleyGrey":"#818181","shadowMountain":"#585858","lcPrimary":"#00203f","lcSecondary":"#fdfdfd","lcLightPrimary":"#bf0a2f","lcHover":"#eef7ff","lcLink":"#ff9a03","lcButton":"#bf0a2f","lcProgress":"#9e9d9e","whyUsTitle":"#2e2e2e","whyUsItemBrief":"#747474","headerPhoneColor":"#dd6453","headerCallCenter":"#129188","goGoGreen":"#008a7b","bankVault":"#747474","secondary":"#444b53","progress":"#e489a2","hover":"#b31c1a","blue":"#0d4085","pink":"#f59aac","hoverBg":"#fef8fb","greyLight":"#f3f3f3","darkGreen":"#00a259","greenButton":"#00a259","purple":"#51378e","orangeHover":"#f1dfd0","grey":"#777","darkRed":"#ae332f","stickBtnBgColor":"#f89a1c","stickBtnBorderColor":"#f89a1c","blueLight":"#e9f9ff","carnival":"#ff9800","nickel":"#2f6177","footerColor":"#2f6177","button":"#fff2f1","darkBlue":"#222e59","lightGreen":"#d3e0c9","purpleLight":"#f6f1ff","purpleDark":"#674998","progressBarColor":"#b0b0b0","sloganColor":"#515151","phoneNumberColor":"#0d7166","popupMainColor":"#4d7ea6","stickTitleColor":"#000","stickBtnTxtColor":"#fff","progressbar":"#9a9a9a","mainColor":"#0071ac","whyUs":"#316767","secondaryColor":"#f2f4ea","tepezzaGrey":"#7d7d7d","paragraphColor":"#232323","iconColor":"#e05d26","whyUsBriefColor":"#747474","gorseYellowOrange":"#ff9800","denimBlue":"#2f6177","item":"styles_item__j6_jF","mainSection":"styles_mainSection__2nFt8","link":"styles_link___4DQd"};

/***/ }),

/***/ 57532:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"green":"#00a259","darkGreen":"#00a259","hover":"#00a259","greenButton":"#00a259","grey":"#585858"};

/***/ })

}]);